import _Transition from "@kibt/meta-ui/es/transition";
import { ref, watch } from '@vue/composition-api';
import { lrpx2px, statusBarHeight } from '@/utils/device';
export var useToScrollHook = function useToScrollHook() {
  var startY = 0;
  var isTouchTop = false;
  var isTouchTopHeight = lrpx2px(Number.isNaN(statusBarHeight) ? 0 : Number(statusBarHeight) + 590);

  var handleTouchStart = function handleTouchStart(e) {
    startY = e.touches[0].pageY;
    isTouchTop = startY < isTouchTopHeight;
  };

  var distance = 0;

  var handleTouchMove = function handleTouchMove(e) {
    distance = e.touches[0].pageY - startY;
  };

  var config = ref({
    value: 0,
    duration: 0,
    timingFunction: 'sineEaseOut'
  });

  var _Transition$useHook = _Transition.useHook(config),
      realValue = _Transition$useHook.realValue;

  var handleTouchEnd = function handleTouchEnd() {
    if (distance < -5 && isTouchTop) {
      // window.scroll;
      var current = document.documentElement.scrollTop;
      config.value.value = current;
      config.value.duration = 0;
      setTimeout(function () {
        config.value.value = isTouchTopHeight;
        config.value.duration = 300;
      });
    } else if (distance > 5 && !isTouchTop) {
      var _current = document.documentElement.scrollTop;
      config.value.value = _current;
      config.value.duration = 0;
      setTimeout(function () {
        config.value.value = 0;
        config.value.duration = 300;
      });
    }

    distance = 0;
    startY = 0;
  };

  watch(function () {
    return realValue.value;
  }, function () {
    document.documentElement.scrollTop = realValue.value;
  });
  return {
    handleTouchStart: handleTouchStart,
    handleTouchMove: handleTouchMove,
    handleTouchEnd: handleTouchEnd
  };
};